# 项目模板相关全局脚本

$ ->
  $(document)
    .on 'ajax:success', '.clone-template', cloneTemplate
    .on 'ajax:success', '.create-project-from-template', createProjectFromTemplate

cloneTemplate = (e, result)->
  return unless result.success
  tpl = '''
    <h3 class="simple-dialog-title">正在复制模板...</h3>
    <p>这个过程通常只需要 3 秒钟。如果原始模板数据量很大，会需要更长的时间。</p>
  '''

  dialog = simple.dialog
    width: 520
    modal: true
    cls: result.task_guid
    clickModalRemove: false
    showRemoveButton: false
    content: tpl
    buttons: null


createProjectFromTemplate = (e, result) ->
  return  unless result.success

  tpl = '''
    <h3 class="simple-dialog-title">正在从模板创建项目...</h3>
    <p>这个过程通常只需要 3 秒钟，项目创建完成后会自动打开。如果模板数据量很大，会需要更长的时间。</p>
  '''

  dialog = simple.dialog
    width: 520
    modal: true
    cls: result.task_guid
    clickModalRemove: false
    showRemoveButton: false
    content: tpl
    buttons: null
